export type ProjectStatus = 'published' | 'archived' | 'draft';

export interface ProjectWindowPreferences {
  width: number;
  height: number;
  minWidth?: number;
  minHeight?: number;
  resizable?: boolean;
}

export interface ProjectCapabilities {
  fullscreen?: boolean;
  downloads?: boolean;
  pointerLock?: boolean;
  clipboard?: boolean;
  popups?: boolean;
}

export interface ProjectMedia {
  icon?: string;
  preview?: string;
}

export interface ProjectManifest {
  schemaVersion: 1;
  slug: string;
  title: string;
  shortTitle?: string;
  summary: string;
  description?: string;
  category: string;
  tags?: string[];
  year?: number;
  publishedAt?: string;
  updatedAt?: string;
  status: ProjectStatus;
  featured?: boolean;
  order?: number;
  sourceUrl?: string;
  homepageUrl?: string;
  media?: ProjectMedia;
  window?: ProjectWindowPreferences;
  capabilities?: ProjectCapabilities;
  runtimeUrl?: string;
  manifestUrl?: string;
}

export interface ProjectRegistryResponse {
  schemaVersion: 1;
  generatedAt: string;
  count: number;
  projects: ProjectManifest[];
}

export function isVisibleProject(project: ProjectManifest): boolean {
  return project.status === 'published' || project.status === 'archived';
}

export function projectDisplayTitle(project: ProjectManifest): string {
  return project.shortTitle || project.title;
}
